import { render, staticRenderFns } from "./PackingSlipForm.vue?vue&type=template&id=bda614a2&scoped=true&"
import script from "./PackingSlipForm.vue?vue&type=script&lang=js&"
export * from "./PackingSlipForm.vue?vue&type=script&lang=js&"
import style0 from "./PackingSlipForm.vue?vue&type=style&index=0&id=bda614a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda614a2",
  null
  
)

export default component.exports